module.exports = require("util");


//////////////////
// WEBPACK FOOTER
// external "util"
// module id = 262
// module chunks = 1